<template>
  <div :class="stepNumber == 2 ? 'block' : 'hidden'">
    <h1 class="registration-form-layout__title">{{ spFormTitle }}</h1>

    <div class="search-preferences-form registration-form-layout registration-form-layout--blue flex">
      <p class="registration-form-layout__note"><b>{{locales && locales.subscription && locales.subscription.search_preferences}}</b> {{locales && locales.subscription && locales.subscription.more_accurate_offers}} {{locales && locales.subscription && locales.subscription.you_can_skip}}</p>

      <theme-autocomplete
        name='location_id[]'
        :label="spCityTitle"
        endpoint="/admin/autocomplete/locations"
        :resolve="(item) => item.name"
        :placeholder="locales && locales.subscription && locales.subscription.add_location"
        :isRequired="true"
        v-validate="`required|location`"
      ></theme-autocomplete>

      <theme-districts-dropdown 
        :data="[]"
        name='districts[]' 
        :label="spDistrictTitle"
        :placeholder="spDistrictPlaceholder"
        :district-input="true"
      ></theme-districts-dropdown>

      <theme-select
        :name="'distance'"
        :label="spDistanceTitle"
        :value="spDistanceValue"
        :options="spDistanceOptions"
      ></theme-select>

      <theme-input
        :label="spRentalTextTitle"
        name="rental_text"
        :placeholder="spRentalTextPlaceholder"
      ></theme-input>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7">
        <theme-calendar
            :label="spStartDateRentTitle"
            name="rental_starts_at"
            :placeholder="spStartDateRentPlaceholder"
        ></theme-calendar>

        <theme-input
          :label="spWeekPriceTitle"
          name="week_price"
          v-validate="`required|numeric`"
          :isRequired="true"
          placeholder="0,00"
          :isExtraInfo="true"
        >
          <template slot="extra-info">
            <span class="text-black">€</span>
          </template>
        </theme-input>

        <theme-input
          :label="spNumberOfMenTitle + ', male'"
          name="number_of_men"
          v-validate="`required|numeric`"
          :isRequired="true"
          :placeholder="spNumberOfMenPlaceholder"
        ></theme-input>

        <theme-input
          :label="spNumberOfWomenTitle"
          name="number_of_women"
          v-validate="`required|numeric`"
          :isRequired="true"
          :placeholder="spNumberOfWomenPlaceholder"
        ></theme-input>

        <theme-select
          :label="spBedroomsTitle"
          :value="spBedroomsValue"
          name="min_number_of_bedrooms"
          :options="spBedroomsOptions"
        ></theme-select>

        <theme-select
          :label="spParkingPlacesTitle"
          :value="'0'"
          name="parking_places"
          :options="spParkingPlacesOptions"
          v-validate="`required`"
          :isRequired="true"
        ></theme-select>
      </div>

      <theme-textarea
        :label="spExtraInformationTitle"
        name="searchprofile_subscriber_note"
        :placeholder="spExtraInformationPlaceholder"
      ></theme-textarea>

      <button
        id="submitSearchPreferencesFormBtn"
        class="theme-btn theme-btn--block theme-btn--primary"
        type="submit"
        @click.prevent="submitForm"
      >
        Submit
      </button>

    </div>
</div>
</template>

<script>
import $ from "jquery";
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";

import ThemeInput from "./ThemeInput.vue";
import ThemeCheckboxes from "./ThemeCheckboxes.vue";
import ThemeLocationDropdown from "./ThemeLocationDropdown.vue";
import ThemeCalendar from "./ThemeCalendar.vue";
import ThemeSelect from "./ThemeSelect.vue";
import ThemeTextarea from "./ThemeTextarea.vue";

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ThemeInput,
    ThemeCheckboxes,
    ThemeLocationDropdown,
    ThemeCalendar,
    ThemeSelect,
    ThemeTextarea,
  },
  // data() {},
  computed: {
    ...mapGetters(["locales"]),
    stepNumber: function() {
      return this.$store.state.registrationStep.stepNumber;
    },
  },
  props: {
    spCityTitle: {
      default: '',
			type: String
    },
    spFormTitle: {
			default: '',
			type: String
		},
    spNoPreference: {
			default: '',
			type: String
		},
    spDistrictTitle: {
			default: '',
			type: String
		},
    spDistrictPlaceholder: {
			default: '',
			type: String
		},
    spDistanceTitle: {
			default: '',
			type: String
		},
    spDistanceOptions: {
			default: () => { },
			type: Object
		},
		spDistanceValue: {
			default: '',
			type: String
		},
		spWeekPriceTitle: {
			default: '',
			type: String
		},
		spNumberOfMenTitle: {
			default: '',
			type: String
		},
		spNumberOfMenPlaceholder: {
			default: '',
			type: String
		},
		spNumberOfWomenTitle: {
			default: '',
			type: String
		},
    spNumberOfWomenPlaceholder: {
			default: '',
			type: String
		},
    spBedroomsTitle: {
			default: '',
			type: String
		},
		spBedroomsOptions: {
			default: () => { },
			type: Object
		},
		spBedroomsValue: {
			default: '',
			type: String
		},
    spStartDateRentTitle: {
			default: '',
			type: String
		},
		spStartDateRentValue: {
			default: '',
			type: String
		},
		spStartDateRentPlaceholder: {
			default: '',
			type: String
		},
    spExtraInformationTitle: {
			default: '',
			type: String
		},
		spExtraInformationPlaceholder: {
			default: '',
			type: String
		},
    spRentalTextTitle: {
			default: '',
			type: String
		},
    spRentalTextPlaceholder: {
			default: '',
			type: String
		},
    spParkingPlacesTitle: {
			default: '',
			type: String
		},
		spParkingPlacesOptions: {
			default: () => { },
			type: Object
		},

  },
  methods: {
    submitForm: function (e) {
      e.preventDefault();
      if (this.isSubmitInProgress) return;
      let that = this;
      this.isSubmitInProgress = true;
      this.$validator.validateAll().then((res) => {
        if (res) {
          const form = $("#form");
          const data = form.serialize();
          const element = document.getElementById("submitSearchPreferencesFormBtn");

          element.classList.add("disabled-state");
          setTimeout(function () {
            element.classList.remove("disabled-state");
          }, 2000);

          $.ajax({
            url: form.attr("action"),
            method: "post",
            data: data,
            success: function (result) {
              that.isSubmitInProgress = false;
              if (result && result.status && result.status == "error") {
                var message = result.message;
                sweetalert(window.app.locales.common.error, message, "error");
                // sweetalert('Erorr in fetch request', 'Please, try again later', "error");
              } else {
                sweetalert(
                  window.app.locales.common.success,
                  window.app.locales.common.success_candidate_subscribe,
                  "success"
                ).then((res) => {
                  window.location.replace(result.url);
                });
              }
            },
            error: function (jqXHR, exception) {
              that.isSubmitInProgress = false;
              var message = jqXHR.responseJSON.message;
              sweetalert(window.app.locales.common.error, message, "error");
            },
          });
        } else {
          that.isSubmitInProgress = false;
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },
  },
  updated() {
  },
}
</script>